<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    return {
      mindset_scale: 0,
      form: {
        active: true,
      },
      disableOnSubmit: false,
      dictionary: {
        en: {
          attributes: {
            my_notion_of_ten:
              "Perhaps start by defining a 10/10 score and then consider what a few others scores might look like on the way down to 0. Then rate yourself, further below.",
            my_current_score: "My Current Score",
            my_aspirational_score: "My Aspirational Score",
          },
        },
      },
    };
  },

  props: ["url", "getUrl", "average", "mindset", "questions", "scaleUrl"],

  mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {
    this.getData();
    this.$validator.localize(this.dictionary);
  },

  watch: {},

  methods: {
    getData() {
      axios
        .get(this.getUrl, {
          params: {},
        })
        .then((response) => {
          this.form = response.data.data;
          this.mindset_scale = this.form.scale != null ? this.form.scale : 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    formatName(name) {
      name = name.replace(/-/g, " ");
      return name.charAt(0).toUpperCase() + name.slice(1);
    },

    getEditUrl(question) {
      return window.location.href + "/" + question.trait + "?edit=true";
    },

    updateScale() {
        axios
            .put(this.scaleUrl,
                {
                    scale: this.mindset_scale,
                }
            )
            .then(response => {
                this.$root.$refs.toastr.s(response.data.message);
            })
            .catch(error => {
                console.log(error);
                this.$root.$refs.toastr.e("ERROR");
            });
    },
  },

  components: {
    VueSlider,
  },
};
</script>
